module.exports = __webpack_public_path__ + "img/carousel-servicios-4.a0c1d712.jpg";